<template>
    <div class="os">
        <div class="os__container os__container--name">
            <h2 class="os__title" v-text="$ml.get('customerName')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="customer.Name"
            />
        </div>
        <div class="os__container os__container--id">
            <h2 class="os__title" v-text="$ml.get('orderNumber')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="orderNumber"
            />
        </div>
        <div class="os__container os__container--document">
            <h2 class="os__title" v-text="$ml.get('documentNumber')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="customer.Identity"
            />
        </div>
        <div v-if="merchantIdentity" class="os__container os__container--employer-number">
            <h2 class="os__title" v-text="$ml.get('employerNumber')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="merchantIdentity"    
            />
        </div>
        <div class="os__container os__container--date">
            <h2 class="os__title" v-text="$ml.get('paymentDate')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="localizeOrderDate(orderDate, $ml.current)"    
            />
        </div>
        <div v-if="endToEndId" class="os__container os__container--transaction-id">
            <h2 class="os__title" v-text="$ml.get('transactionId')" tabindex="0" />
            <strong 
                class="os__text"
                tabindex="0"
                v-text="endToEndId"    
            />
        </div>
        <div class="os__container os__container--method">
            <img class="card-brand" v-if="paymentMethod.Type === 8" src="@/assets/img/payment-types/multi-card.svg" />
            <CardBrand v-else-if="paymentMethod.Brand !== 'undefined'" :brand="paymentMethod.Brand" tabindex="0" />
            <PaymentTypeIcon v-else :payment-type="paymentMethod.Type" tabindex="0" />
            <div class="card-info">
                <span v-text="$ml.get(getPaymentMethodTranslationParameterName())" />
                <p
                    v-if="hasInstallmentsInfo"
                >
                    <strong class="os__text" v-if="paymentMethod.CardLastFour"> {{ '&bull;&bull;&bull;&bull; ' + paymentMethod.CardLastFour }}</strong>
                    <strong
                        class="os__text"
                        v-if="paymentMethod.IsRecurringPayment"
                    >
                        {{ formatPrice(paymentMethod.InstallmentPrice) }}
                    </strong>

                    <strong
                        class="os__text"
                        v-else
                    >
                        {{ paymentMethod.InstallmentsNumber }}x
                        <strong class="os__text" v-text="$ml.get('of')" />
                        {{ formatPrice(paymentMethod.InstallmentPrice) }}
                    </strong>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CardBrand from '@/components/CardBrand';
    import PaymentTypeIcon from '@/components/PaymentTypeIcon';
    import translationParameterHelper from '@/config/lang/helpers/translationParameterHelper';
    import moneyHelper from '@/helpers/moneyHelper';
    import PaymentTypes from '@/models/PaymentTypes';

    export default {
        data() {
          return {};
        },

        props: {},

        components: {
            CardBrand,
            PaymentTypeIcon,
        },

        computed: {
            ...mapGetters({
                orderNumber: 'orderStatus/getOrderNumber',
                customer: 'orderStatus/getCustomer',
                orderDate: 'orderStatus/getCreatedDate',
                paymentMethod: 'orderStatus/getPaymentMethod',
                merchantIdentity: 'orderStatus/getMerchantIdentity',
                endToEndId: 'orderStatus/getEndToEndId',
            }),

            hasInstallmentsInfo() {
                return this.paymentMethod.Type === PaymentTypes.CREDIT_CARD ||
                    this.paymentMethod.Type === PaymentTypes.QRCODE ||
                    this.paymentMethod.Type === PaymentTypes.PAT_ELO_VOUCHER;
            }
        },

        methods: {
            localizeOrderDate(orderDate, currentLocale) {
                const pattern = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
                let date = new Date(
                    orderDate.replace(pattern, '$3-$2-$1T$4:$5:$6Z')
                );

                return date.toLocaleString(currentLocale, {
                    timeZone: 'America/Sao_Paulo',
                    dateStyle: 'medium',
                    timeStyle: 'medium'
                });
            },
            getPaymentMethodTranslationParameterName() {
                return translationParameterHelper
                  .getPaymentMethodTranslationParameterName(this.paymentMethod.Type);
            },
            formatPrice(unitPrice) {
                let totalPrice = unitPrice / 100; // Transforma centavos em real.

                return `R$ ${moneyHelper.formatToPrice(totalPrice)}`;
            }
        },

    };
</script>

<style lang="scss" scoped>
  .os {
      background-color: #EFF1F3;
      border-radius: 12px;
      padding: 20px;

      &__container {
          &:not(:last-child) {
              margin-bottom: 24px;
          }

          &--name {}

          &--id {}

          &--document {}

          &--date {}

          &--method {
              display: flex;
              align-items: center;
              color: #000000;

              .card-brand,
              .payment-type-icon {
                  margin-right: 12px;
              }

              .card-info {
                  display: flex;
                  flex-direction: column;
                  width: 100%;

                  
                  span {
                      font-size: 14px;
                      font-weight: 500;
                      line-height: 10px;
                  }

                  p {
                      display: flex;
                      justify-content: space-between;
                      margin: 12px 0 0;

                      > strong {
                         &:first-child {
                              margin-right: 8px;
                         }
                      }
                  }
              }

          }
      }

      &__title {
          font-size: 14px;
          font-weight: 500;
          line-height: 10px;
          color: #000000;
          margin-bottom: 8px;
      }

      &__text {
          font-size: 16px;
          font-weight: 600;
          line-height: 11px;
          color: #000000;
      }
  }
</style>
